import React, { useEffect, useState } from 'react';
import { Gallery } from "react-grid-gallery";
import { convertYouTubeURL, getThumbnailUrlFromEmbedLink } from '../helper/getThumbnailUrlFromEmbedLink';
import { useLocation } from 'react-router';
import { useTranslate } from '../components/TranslationText';
import { useSelector } from 'react-redux';
import axios from '../axios/axiosUmbraco';
import { formatDate } from '../helper/formatDate';
import CustomButton from '../components/CustomButton';
import axiosUmbraco from '../axios/axiosUmbraco';
import ImageViewer from '../components/ImageViewer';

const GalleryId = process.env.REACT_APP_GALLERY_ID;
const MediaBaseURL = process.env.REACT_APP_BACKEND_API;

export default function AlbumPage({ toast, data }) {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const currentAlbumId = searchParams.has("id")
        ? searchParams.get("id")
        : false;

    const { translate } = useTranslate();

    const [gallery, setGalleryItems] = useState([]);
    const [loaded, setLoaded] = useState(false);

    // Pagination states
    const [page, setPage] = useState(1); // Current page
    const [pageSize] = useState(20); // Number of images per page
    const [formattedImages, setFormattedImages] = useState([]);
    const [images, setImages] = useState([]);
    const [imageslightbox, setImageslightbox] = useState([]);


    useEffect(() => {
        async function fetchData() {
            try {
                const umbraco = await axiosUmbraco.get(
                    `/umbraco/delivery/api/v1/content/item?id=${currentAlbumId}`,
                );



                const formattedData = umbraco.data?.map((item) => ({
                    albumName: item?.properties?.albumName ?? "",
                    albumVideos: item?.properties?.albumMedia ?? [],
                    albumImages: item?.properties?.albumImages ?? [],
                    eventStartDate: item?.properties?.eventStartDate ?? '',
                    eventEndDate: item?.properties?.eventEndDate ?? '',
                    mediaFolderPath: item?.properties?.mediaFolderPath ?? '',
                }));

                if (formattedData[0].mediaFolderPath != '') {
                    const folderImages = await axios.get(`umbraco/delivery/api/v2/media?fetch=children:${formattedData[0].mediaFolderPath}&skip=0&take=2000`)

                    if (folderImages.data.items.length > 0) {
                        const images = folderImages.data.items.map((image, index) => ({
                            src: MediaBaseURL + image.url,
                            width: 320,
                            isvideo: false,
                            height: 174,
                            caption: image.name,
                        }));

                        const videos = formattedData[0].albumVideos.map((video, index) => ({
                            src: video.properties.albumVideo,
                            width: 320,
                            isvideo: true,
                            height: 174,
                            caption: 'video',
                        }));

                        setGalleryItems(formattedData);
                        setFormattedImages([...videos, ...images]);
                        setImages(reformatImages([...videos, ...images], false));
                        setImageslightbox(reformatImages([...videos, ...images], true));
                        setLoaded(true);
                    }
                }

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }

        fetchData();
    }, []);

    // Function to load more images
    const loadMoreImages = () => {
        // Here you can implement logic to fetch more images or simply increment the page number
        // For demonstration, let's increment the page number
        setPage(page + 1);
    };

    function reformatImages(images, isLightBox) {
        if (isLightBox !== true) {
            return (
                images.map((image, index) => ({
                    src: image.isvideo ? convertYouTubeURL(getThumbnailUrlFromEmbedLink(image.src)) : getThumbnailUrlFromEmbedLink(image.src),
                    width: image.width,
                    height: image.height,
                    isvideo: image.isvideo,
                    tags: image.isvideo ? [
                        { value: <i className="fa-solid fa-play" style={{ fontSize: 18 }}></i> },
                    ] : [],
                }))
            );
        } else {
            return (
                images.map((image, index) => ({
                    src: image.isvideo ? convertYouTubeURL(image?.src) : image?.src,
                    width: image.width,
                    height: image.height,
                    isvideo: image.isvideo,
                    tags: image.isvideo ? [
                        { value: <i className="fa-solid fa-play" style={{ fontSize: 18 }}></i> },
                    ] : [],
                }))
            );
        }
    }

    const [index, setIndex] = useState(-1);
    const handleClick = (index) => setIndex(index);



    return (
        <div className='container-fluid px75'>
            {loaded &&
                gallery.map((album, index) => (
                    <React.Fragment key={index}>
                        <div className='row m0 rtl'>
                            <h2 className='supplierTitle'>
                                {album.albumName}
                            </h2>
                        </div>
                        <div className='row m0 justRotate'>
                            <div className="col-md-2  showDetaisLabel justRotate rtl">
                                <i
                                    className="fa fa-calendar C89C66"
                                    style={{ margin: "0 5px" }}
                                ></i>
                                <span>{translate('web.from', 'From')} : {formatDate(album.eventStartDate)}</span>
                            </div>
                            <div className="col-md-2  showDetaisLabel justRotate rtl">
                                <i
                                    className="fa fa-calendar C89C66"
                                    style={{ margin: "0 5px" }}
                                ></i>
                                <span>{translate('web.to', 'To')} : {formatDate(album.eventStartDate)}</span>
                            </div>
                        </div>
                        <div className='row m0 rtl'>
                            <style>
                                {`.ReactGridGallery{
                                    padding:0;
                                }`}
                            </style>
                            <Gallery
                                images={images.slice(0, page * pageSize)} // Displaying images based on pagination
                                onClick={(index) => handleClick(index)} // Handle click logic
                                enableImageSelection={false}
                                thumbnailStyle={{ height: "unset", width: '100%' }}
                            />
                        </div>
                        {formattedImages.length > page * pageSize && ( // Check if there are more images to load
                            <div className='row justify-content-center text-center'>
                                <div className='col-lg-2 col-md-2 col-sm-12 mt-3'>
                                    <CustomButton label={translate('web.loadMore', 'Load More')} type={'submit'} onClick={loadMoreImages} className="loadMoreBtn" />
                                </div>
                            </div>
                        )}
                    </React.Fragment>
                ))}

            <ImageViewer
                index={index}
                setIndex={setIndex}
                images={images}
            />
        </div>
    );
}
